var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact-bg",
    className: "contact-bg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3585.368,
    height: 450,
    viewBox: "0 0 3585.368 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(938.208 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image",
    "data-name": "Icon - Image",
    transform: "translate(54.745 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 78.538,
    height: 12.736,
    rx: 6.368,
    transform: "translate(31.84 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 78.538,
    height: 13.797,
    rx: 6.899,
    transform: "translate(31.84 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 33.962,
    height: 7.429,
    rx: 3.715,
    transform: "translate(31.84 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 33.962,
    height: 7.429,
    rx: 3.715,
    transform: "translate(76.415 153.892)",
    fill: "#fbfbf2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "group-2",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1096.344 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-2",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-2",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-2",
    "data-name": "Icon - Image",
    transform: "translate(29.481 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-3",
    "data-name": "Icon - Image",
    transform: "translate(87.701 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-2",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "group-3",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(780.071)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-3",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(1.061 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-3",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-4",
    "data-name": "Icon - Image",
    transform: "translate(81.887 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-4",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-4",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 44.575,
    height: 8.491,
    rx: 4.245,
    transform: "translate(59.434 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-2",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(6.368 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    transform: "translate(59.434 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.802,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 60.802,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(10.613 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.205,
    cy: 12.736,
    rx: 12.205,
    ry: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.205,
    cy: 12.736,
    rx: 9.705,
    ry: 10.236,
    fill: "none"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "group-4",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(782.193 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-4",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-5",
    "data-name": "Icon - Image",
    transform: "translate(57.698 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-5",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-5",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-3",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(13.797 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(13.797 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-3",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(13.797 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(112.5 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(112.5 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 3.184,
    transform: "translate(112.5 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(13.797 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-2",
    "data-name": "Rectangle 9",
    transform: "translate(13.797 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-4",
    "data-name": "Rectangle 4",
    d: "M0,0H140.094a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "group-5",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1096.345 0)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-5",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-6",
    "data-name": "Icon - Image",
    transform: "translate(58.122 56.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-6",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-6",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-4",
    "data-name": "Rectangle 7",
    width: 112.5,
    height: 10.613,
    rx: 5.307,
    transform: "translate(13.797 98.703)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-3",
    "data-name": "Rectangle 11",
    width: 112.5,
    height: 11.675,
    rx: 5.837,
    transform: "translate(13.797 117.807)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-4",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(13.797 136.91)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-2",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-2",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(13.797 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-3",
    "data-name": "Rectangle 9",
    transform: "translate(13.797 41.391)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.5,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 107.5,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-5",
    "data-name": "Rectangle 4",
    d: "M0,0H140.094a0,0,0,0,1,0,0V17.594a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "group-6",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(938.208 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-6",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(1.061 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-6",
    "data-name": "Rectangle 4",
    d: "M10,0H99.764a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-5",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-2",
    "data-name": "Rectangle 13",
    width: 39.269,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 39.269,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.043 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.043 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 65.802,
    height: 6.368,
    rx: 3.184,
    transform: "translate(18.043 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    transform: "translate(15.92 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 12.736,
    ry: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 10.236,
    ry: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-4",
    "data-name": "Rectangle 9",
    transform: "translate(20.165 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.679,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 58.679,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-7",
    "data-name": "Icon - Image",
    transform: "translate(39.251 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-7",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-7",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "group-7",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1247.052 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-7",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-7",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-8",
    "data-name": "Icon - Image",
    transform: "translate(29.019 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-8",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-8",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-9",
    "data-name": "Icon - Image",
    transform: "translate(87.238 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-9",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-9",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-5",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-4",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-6",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-5",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-3",
    "data-name": "Rectangle 10",
    transform: "translate(72.17 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "group-8",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1248.113 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-8",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-10",
    "data-name": "Icon - Image",
    transform: "translate(58.006 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-10",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-10",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-6",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-5",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-7",
    "data-name": "Rectangle 12",
    width: 55.189,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 38.208,
    height: 11.675,
    rx: 5.837,
    transform: "translate(87.028 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-3",
    "data-name": "Rectangle 30",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(106.132 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-3",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(81.722 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-6",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(14.858 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 4.399,
    fill: "none"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "group-9",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1404.128)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-9",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-8",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-11",
    "data-name": "Icon - Image",
    transform: "translate(81.347 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-11",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-11",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-2",
    "data-name": "Rectangle 21",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 44.575,
    height: 8.491,
    rx: 4.245,
    transform: "translate(59.434 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-2",
    "data-name": "Rectangle 23",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-2",
    "data-name": "Rectangle 22",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-8",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-3",
    "data-name": "Rectangle 13",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-3",
    "data-name": "Rectangle 14",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(5.307 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-4",
    "data-name": "Rectangle 10",
    transform: "translate(59.434 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.802,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 60.802,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-3",
    "data-name": "Ellipse 2",
    transform: "translate(9.552 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 10.236,
    fill: "none"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "group-10",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1405.189 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-10",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-12",
    "data-name": "Icon - Image",
    transform: "translate(58.218 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-12",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-12",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-7",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-6",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-9",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-4",
    "data-name": "Rectangle 30",
    width: 11.675,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-3",
    "data-name": "Rectangle 32",
    width: 11.675,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-3",
    "data-name": "Rectangle 33",
    width: 11.675,
    height: 3.184,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-4",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-7",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-9",
    "data-name": "Rectangle 4",
    d: "M0,0H140.094a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "group-11",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2504.943 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-11",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-10",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-13",
    "data-name": "Icon - Image",
    transform: "translate(29.579 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-13",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-13",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-14",
    "data-name": "Icon - Image",
    transform: "translate(87.799 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-14",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-14",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-8",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-7",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-10",
    "data-name": "Rectangle 12",
    width: 81.722,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-8",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-5",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "group-12",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2663.081)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-12",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-11",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-15",
    "data-name": "Icon - Image",
    transform: "translate(80.846 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-15",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-15",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-3",
    "data-name": "Rectangle 15",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 53.066,
    height: 7.429,
    rx: 3.715,
    transform: "translate(72.17 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-3",
    "data-name": "Rectangle 21",
    width: 53.066,
    height: 7.429,
    rx: 3.715,
    transform: "translate(72.17 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 43.514,
    height: 8.491,
    rx: 4.245,
    transform: "translate(59.434 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-3",
    "data-name": "Rectangle 23",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-3",
    "data-name": "Rectangle 22",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-11",
    "data-name": "Rectangle 12",
    width: 31.84,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-4",
    "data-name": "Rectangle 13",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-4",
    "data-name": "Rectangle 14",
    width: 31.84,
    height: 7.429,
    rx: 3.715,
    transform: "translate(5.306 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-6",
    "data-name": "Rectangle 10",
    transform: "translate(59.434 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.802,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 60.802,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-4",
    "data-name": "Ellipse 2",
    transform: "translate(8.49 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.267,
    cy: 12.736,
    rx: 13.267,
    ry: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.267,
    cy: 12.736,
    rx: 10.767,
    ry: 10.236,
    fill: "none"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "group-13",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2506.005 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-13",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-16",
    "data-name": "Icon - Image",
    transform: "translate(58.567 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-16",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-16",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-9",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-8",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-12",
    "data-name": "Rectangle 12",
    width: 56.25,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    width: 39.269,
    height: 11.675,
    rx: 5.837,
    transform: "translate(87.028 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-5",
    "data-name": "Rectangle 30",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(107.193 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-5",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(82.783 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-9",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3",
    transform: "translate(14.858 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 7.429,
    ry: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 4.929,
    ry: 4.399,
    fill: "none"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "group-14",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2663.08 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-14",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-17",
    "data-name": "Icon - Image",
    transform: "translate(58.779 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-17",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-17",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-10",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-9",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-13",
    "data-name": "Rectangle 12",
    width: 72.17,
    height: 12.736,
    rx: 6.368,
    transform: "translate(15.92 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-6",
    "data-name": "Rectangle 30",
    width: 11.675,
    height: 2.123,
    transform: "translate(114.623 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-4",
    "data-name": "Rectangle 32",
    width: 11.675,
    height: 1.061,
    transform: "translate(114.623 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-4",
    "data-name": "Rectangle 33",
    width: 11.675,
    height: 3.184,
    transform: "translate(114.623 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-6",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-10",
    "data-name": "Rectangle 9",
    transform: "translate(15.92 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-12",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "group-15",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1871.109 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-15",
    "data-name": "Rectangle 3",
    width: 139.033,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-13",
    "data-name": "Rectangle 4",
    d: "M10,0H129.033a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-18",
    "data-name": "Icon - Image",
    transform: "translate(28.477 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-18",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-18",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-19",
    "data-name": "Icon - Image",
    transform: "translate(86.697 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-19",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-19",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-11",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-10",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-14",
    "data-name": "Rectangle 12",
    width: 79.599,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-11",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.005,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 47.005,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-7",
    "data-name": "Rectangle 10",
    transform: "translate(72.17 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "group-16",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2343.396 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-16",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-14",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-20",
    "data-name": "Icon - Image",
    transform: "translate(29.461 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-20",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-20",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-21",
    "data-name": "Icon - Image",
    transform: "translate(87.681 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-21",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-21",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-12",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-11",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-15",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-12",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-8",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "group-17",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2027.123)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-17",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(1.061 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-15",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-22",
    "data-name": "Icon - Image",
    transform: "translate(81.867 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-22",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-22",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-4",
    "data-name": "Rectangle 15",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(60.495 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-4",
    "data-name": "Rectangle 21",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 44.575,
    height: 8.491,
    rx: 4.245,
    transform: "translate(60.495 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-4",
    "data-name": "Rectangle 23",
    width: 31.84,
    height: 7.429,
    rx: 3.715,
    transform: "translate(60.495 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(60.495 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-4",
    "data-name": "Rectangle 22",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(60.495 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-16",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-5",
    "data-name": "Rectangle 13",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-5",
    "data-name": "Rectangle 14",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(6.368 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-9",
    "data-name": "Rectangle 10",
    transform: "translate(60.495 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.741,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 59.741,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-5",
    "data-name": "Ellipse 2",
    transform: "translate(10.613 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.205,
    cy: 12.736,
    rx: 12.205,
    ry: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.205,
    cy: 12.736,
    rx: 9.705,
    ry: 10.236,
    fill: "none"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "group-18",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1871.109 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-18",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-23",
    "data-name": "Icon - Image",
    transform: "translate(58.526 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-23",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-23",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-13",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-12",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-17",
    "data-name": "Rectangle 12",
    width: 55.189,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-3",
    "data-name": "Rectangle 29",
    width: 39.269,
    height: 11.675,
    rx: 5.837,
    transform: "translate(87.028 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-7",
    "data-name": "Rectangle 30",
    width: 20.165,
    height: 11.675,
    rx: 5.837,
    transform: "translate(106.132 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-7",
    "data-name": "Rectangle 31",
    width: 20.165,
    height: 11.675,
    rx: 5.837,
    transform: "translate(81.722 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-13",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-3",
    "data-name": "Ellipse 3",
    transform: "translate(14.858 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 7.429,
    ry: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 4.929,
    ry: 4.399,
    fill: "none"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "group-19",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2028.184 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-19",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-24",
    "data-name": "Icon - Image",
    transform: "translate(58.739 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-24",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-24",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-14",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-13",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-18",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-8",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-5",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-5",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 3.184,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-8",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-14",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-16",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "group-20",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2342.335 0)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-20",
    "data-name": "Rectangle 3",
    width: 142.217,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-25",
    "data-name": "Icon - Image",
    transform: "translate(59.163 56.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-25",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-25",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-15",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 98.703)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-14",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 117.807)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-19",
    "data-name": "Rectangle 12",
    width: 74.292,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 136.91)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-9",
    "data-name": "Rectangle 30",
    width: 11.675,
    height: 2.123,
    transform: "translate(114.623 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-6",
    "data-name": "Rectangle 32",
    width: 11.675,
    height: 1.061,
    transform: "translate(114.623 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-6",
    "data-name": "Rectangle 33",
    width: 11.675,
    height: 2.123,
    transform: "translate(114.623 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-9",
    "data-name": "Rectangle 31",
    width: 20.165,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-15",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 41.391)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-17",
    "data-name": "Rectangle 4",
    d: "M0,0H142.217a0,0,0,0,1,0,0V17.594a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "group-21",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2185.26 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-21",
    "data-name": "Rectangle 3",
    width: 142.217,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-18",
    "data-name": "Rectangle 4",
    d: "M10,0H99.764a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-20",
    "data-name": "Rectangle 12",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-2",
    "data-name": "Rectangle 24",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-6",
    "data-name": "Rectangle 13",
    width: 37.146,
    height: 6.368,
    rx: 3.184,
    transform: "translate(45.637 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-2",
    "data-name": "Rectangle 26",
    width: 37.146,
    height: 6.368,
    rx: 3.184,
    transform: "translate(45.637 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-6",
    "data-name": "Rectangle 14",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.042 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.042 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-2",
    "data-name": "Rectangle 28",
    width: 64.741,
    height: 6.368,
    rx: 3.184,
    transform: "translate(18.042 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-6",
    "data-name": "Ellipse 2",
    transform: "translate(16.981 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.205,
    cy: 12.205,
    r: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.205,
    cy: 12.205,
    r: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-16",
    "data-name": "Rectangle 9",
    transform: "translate(19.104 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.679,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 58.679,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-26",
    "data-name": "Icon - Image",
    transform: "translate(39.231 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-26",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-26",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "group-22",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1562.264 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-22",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-19",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-27",
    "data-name": "Icon - Image",
    transform: "translate(54.205 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-27",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-27",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    width: 78.538,
    height: 12.736,
    rx: 6.368,
    transform: "translate(30.778 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-16",
    "data-name": "Rectangle 7",
    width: 78.538,
    height: 13.797,
    rx: 6.899,
    transform: "translate(30.778 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-2",
    "data-name": "Rectangle 6",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(30.778 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 33.962,
    height: 7.429,
    rx: 3.715,
    transform: "translate(75.354 153.892)",
    fill: "#fbfbf2"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "group-23",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2184.943 57.146)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-23",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-20",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-28",
    "data-name": "Icon - Image",
    transform: "translate(54.205 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-28",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-28",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-3",
    "data-name": "Rectangle 5",
    width: 78.538,
    height: 12.736,
    rx: 6.368,
    transform: "translate(30.778 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-17",
    "data-name": "Rectangle 7",
    width: 78.538,
    height: 13.797,
    rx: 6.899,
    transform: "translate(30.778 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-3",
    "data-name": "Rectangle 6",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(30.778 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-3",
    "data-name": "Rectangle 8",
    width: 33.962,
    height: 7.429,
    rx: 3.715,
    transform: "translate(75.354 153.892)",
    fill: "#fbfbf2"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "group-24",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1719.34 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-24",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-21",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-29",
    "data-name": "Icon - Image",
    transform: "translate(30.002 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-29",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-29",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-30",
    "data-name": "Icon - Image",
    transform: "translate(88.222 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-30",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-30",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-18",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-15",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-21",
    "data-name": "Rectangle 12",
    width: 79.599,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-17",
    "data-name": "Rectangle 9",
    transform: "translate(15.92 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-10",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "group-25",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1719.34 0)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-25",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-31",
    "data-name": "Icon - Image",
    transform: "translate(58.642 56.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-31",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-31",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-19",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 98.703)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-16",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 117.807)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-22",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 136.91)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-10",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-7",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-7",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-10",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-18",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 41.391)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-22",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V17.594a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "group-26",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(1562.264 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-26",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-23",
    "data-name": "Rectangle 4",
    d: "M10,0H99.764a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-23",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-3",
    "data-name": "Rectangle 24",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-3",
    "data-name": "Rectangle 25",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.01 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-7",
    "data-name": "Rectangle 13",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-3",
    "data-name": "Rectangle 26",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-7",
    "data-name": "Rectangle 14",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.042 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-3",
    "data-name": "Rectangle 27",
    width: 64.741,
    height: 7.429,
    rx: 3.715,
    transform: "translate(18.042 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-3",
    "data-name": "Rectangle 28",
    width: 64.741,
    height: 6.368,
    rx: 3.184,
    transform: "translate(18.042 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-7",
    "data-name": "Ellipse 2",
    transform: "translate(15.92 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 12.736,
    ry: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 10.236,
    ry: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-19",
    "data-name": "Rectangle 9",
    transform: "translate(19.104 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.679,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 58.679,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-32",
    "data-name": "Icon - Image",
    transform: "translate(38.711 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-32",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-32",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "group-27",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(472.288 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-27",
    "data-name": "Rectangle 3",
    width: 142.217,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-24",
    "data-name": "Rectangle 4",
    d: "M10,0H132.217a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-33",
    "data-name": "Icon - Image",
    transform: "translate(30.022 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-33",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-33",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-34",
    "data-name": "Icon - Image",
    transform: "translate(88.242 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-34",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-34",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-20",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-17",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-24",
    "data-name": "Rectangle 12",
    width: 81.722,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-20",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-11",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "group-28",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(472.288 0)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-28",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-35",
    "data-name": "Icon - Image",
    transform: "translate(58.662 56.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-35",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-35",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-21",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 98.703)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-18",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 117.807)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-25",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 136.91)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-11",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-8",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-8",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-11",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-21",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 41.391)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-25",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V17.594a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "group-29",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(622.995 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-29",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-26",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-36",
    "data-name": "Icon - Image",
    transform: "translate(29.559 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-36",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-36",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-37",
    "data-name": "Icon - Image",
    transform: "translate(87.779 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-37",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-37",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-22",
    "data-name": "Rectangle 7",
    width: 109.316,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-19",
    "data-name": "Rectangle 11",
    width: 109.316,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-26",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 12.736,
    rx: 6.368,
    transform: "translate(15.92 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-22",
    "data-name": "Rectangle 9",
    transform: "translate(15.92 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-12",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.005,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 47.005,
    height: 44.882,
    fill: "none"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "group-30",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(624.057 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-30",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-38",
    "data-name": "Icon - Image",
    transform: "translate(58.547 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-38",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-38",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-23",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-20",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-27",
    "data-name": "Rectangle 12",
    width: 55.189,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-4",
    "data-name": "Rectangle 29",
    width: 37.146,
    height: 11.675,
    rx: 5.837,
    transform: "translate(88.09 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-12",
    "data-name": "Rectangle 30",
    width: 18.042,
    height: 11.675,
    rx: 5.837,
    transform: "translate(107.193 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-12",
    "data-name": "Rectangle 31",
    width: 18.042,
    height: 11.675,
    rx: 5.837,
    transform: "translate(82.783 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-23",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-4",
    "data-name": "Ellipse 3",
    transform: "translate(14.858 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 7.429,
    ry: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.429,
    cy: 6.899,
    rx: 4.929,
    ry: 4.399,
    fill: "none"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "group-31",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(315.212 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-31",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-27",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-39",
    "data-name": "Icon - Image",
    transform: "translate(54.225 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-39",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-39",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-4",
    "data-name": "Rectangle 5",
    width: 79.599,
    height: 12.736,
    rx: 6.368,
    transform: "translate(30.778 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-24",
    "data-name": "Rectangle 7",
    width: 79.599,
    height: 13.797,
    rx: 6.899,
    transform: "translate(30.778 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-4",
    "data-name": "Rectangle 6",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(30.778 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-4",
    "data-name": "Rectangle 8",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(75.354 153.892)",
    fill: "#fbfbf2"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "group-32",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(0 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-32",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-28",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-40",
    "data-name": "Icon - Image",
    transform: "translate(29.039 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-40",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-40",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-41",
    "data-name": "Icon - Image",
    transform: "translate(87.258 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-41",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-41",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-25",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-21",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-28",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-24",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-13",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.005,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 47.005,
    height: 44.882,
    fill: "none"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "group-33",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(157.076)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-33",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-29",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-42",
    "data-name": "Icon - Image",
    transform: "translate(81.367 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-42",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-42",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-5",
    "data-name": "Rectangle 15",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-5",
    "data-name": "Rectangle 17",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-5",
    "data-name": "Rectangle 21",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-5",
    "data-name": "Rectangle 18",
    width: 44.575,
    height: 8.491,
    rx: 4.245,
    transform: "translate(59.434 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-5",
    "data-name": "Rectangle 23",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-5",
    "data-name": "Rectangle 16",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-5",
    "data-name": "Rectangle 22",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-29",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-8",
    "data-name": "Rectangle 13",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-8",
    "data-name": "Rectangle 14",
    width: 31.84,
    height: 7.429,
    rx: 3.715,
    transform: "translate(6.368 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-14",
    "data-name": "Rectangle 10",
    transform: "translate(59.434 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.802,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 60.802,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-8",
    "data-name": "Ellipse 2",
    transform: "translate(9.552 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 10.236,
    fill: "none"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "group-34",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(0 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-34",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-43",
    "data-name": "Icon - Image",
    transform: "translate(59.088 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-43",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-43",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-26",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-22",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-30",
    "data-name": "Rectangle 12",
    width: 55.189,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-5",
    "data-name": "Rectangle 29",
    width: 38.208,
    height: 11.675,
    rx: 5.837,
    transform: "translate(88.09 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-13",
    "data-name": "Rectangle 30",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(107.193 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-13",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(82.783 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-25",
    "data-name": "Rectangle 9",
    transform: "translate(15.92 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-5",
    "data-name": "Ellipse 3",
    transform: "translate(15.92 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 4.399,
    fill: "none"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "group-35",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(158.137 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-35",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-44",
    "data-name": "Icon - Image",
    transform: "translate(58.238 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-44",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-44",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-27",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-23",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-31",
    "data-name": "Rectangle 12",
    width: 72.17,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-14",
    "data-name": "Rectangle 30",
    width: 11.675,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-9",
    "data-name": "Rectangle 32",
    width: 11.675,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-9",
    "data-name": "Rectangle 33",
    width: 11.675,
    height: 3.184,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-14",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-26",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-30",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "group-36",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(315.212 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-36",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-31",
    "data-name": "Rectangle 4",
    d: "M10,0H98.7a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-32",
    "data-name": "Rectangle 12",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-4",
    "data-name": "Rectangle 24",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-4",
    "data-name": "Rectangle 25",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-9",
    "data-name": "Rectangle 13",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-4",
    "data-name": "Rectangle 26",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-9",
    "data-name": "Rectangle 14",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-4",
    "data-name": "Rectangle 27",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-4",
    "data-name": "Rectangle 28",
    width: 65.802,
    height: 6.368,
    rx: 3.184,
    transform: "translate(16.981 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-9",
    "data-name": "Ellipse 2",
    transform: "translate(15.92 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 12.736,
    ry: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 10.236,
    ry: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-27",
    "data-name": "Rectangle 9",
    transform: "translate(19.104 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.679,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 58.679,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-45",
    "data-name": "Icon - Image",
    transform: "translate(38.731 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-45",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-45",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "group-37",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2821.217 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-37",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-32",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-46",
    "data-name": "Icon - Image",
    transform: "translate(53.704 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-46",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-46",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-5",
    "data-name": "Rectangle 5",
    width: 79.599,
    height: 12.736,
    rx: 6.368,
    transform: "translate(29.717 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-28",
    "data-name": "Rectangle 7",
    width: 79.599,
    height: 13.797,
    rx: 6.899,
    transform: "translate(29.717 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-5",
    "data-name": "Rectangle 6",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(29.717 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-5",
    "data-name": "Rectangle 8",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(74.292 153.892)",
    fill: "#fbfbf2"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "group-38",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2978.292 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-38",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-33",
    "data-name": "Rectangle 4",
    d: "M10,0H131.156a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-47",
    "data-name": "Icon - Image",
    transform: "translate(29.501 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-47",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-47",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-48",
    "data-name": "Icon - Image",
    transform: "translate(87.721 60.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-48",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-48",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-29",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-24",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-33",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-28",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-15",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "group-39",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2978.292 0)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-39",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-49",
    "data-name": "Icon - Image",
    transform: "translate(58.142 56.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-49",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-49",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-30",
    "data-name": "Rectangle 7",
    width: 111.439,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 98.703)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-25",
    "data-name": "Rectangle 11",
    width: 111.439,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 117.807)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-34",
    "data-name": "Rectangle 12",
    width: 73.231,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 136.91)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-15",
    "data-name": "Rectangle 30",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-10",
    "data-name": "Rectangle 32",
    width: 12.736,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-10",
    "data-name": "Rectangle 33",
    width: 12.736,
    height: 2.123,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-15",
    "data-name": "Rectangle 31",
    width: 18.042,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-29",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 41.391)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.439,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 106.439,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-34",
    "data-name": "Rectangle 4",
    d: "M0,0H140.094a0,0,0,0,1,0,0V17.594a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "group-40",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(2821.217 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-40",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-35",
    "data-name": "Rectangle 4",
    d: "M10,0H98.7a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-35",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(102.948 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-5",
    "data-name": "Rectangle 24",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(102.948 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-5",
    "data-name": "Rectangle 25",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(102.948 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-10",
    "data-name": "Rectangle 13",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-5",
    "data-name": "Rectangle 26",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-10",
    "data-name": "Rectangle 14",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-5",
    "data-name": "Rectangle 27",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-5",
    "data-name": "Rectangle 28",
    width: 65.802,
    height: 6.368,
    rx: 3.184,
    transform: "translate(16.981 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-10",
    "data-name": "Ellipse 2",
    transform: "translate(14.858 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 12.736,
    ry: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 10.236,
    ry: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-30",
    "data-name": "Rectangle 9",
    transform: "translate(18.042 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.741,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 59.741,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-50",
    "data-name": "Icon - Image",
    transform: "translate(38.21 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-50",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-50",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "group-41",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3444.212 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-41",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-36",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V89.151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-51",
    "data-name": "Icon - Image",
    transform: "translate(54.225 32.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-51",
    "data-name": "Path 1",
    d: "M106.779,150.506a2.417,2.417,0,1,0-2.679-2.4A2.555,2.555,0,0,0,106.779,150.506Z",
    transform: "translate(-97.412 -139.707)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-51",
    "data-name": "Path 2",
    d: "M29.442,41.7H2.679A2.551,2.551,0,0,0,0,44.1V63.311a2.555,2.555,0,0,0,2.679,2.4H29.448a2.555,2.555,0,0,0,2.679-2.4V44.1A2.561,2.561,0,0,0,29.442,41.7ZM28.106,56.1l-4.034-3.619a2,2,0,0,0-2.7.058c-2.3,2.057-6.649,5.965-6.649,5.965l-2.717-2.438a2.04,2.04,0,0,0-2.634.035L4.022,60.9V45.3h24.09L28.106,56.1Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-6",
    "data-name": "Rectangle 5",
    width: 79.599,
    height: 12.736,
    rx: 6.368,
    transform: "translate(30.778 132.665)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-31",
    "data-name": "Rectangle 7",
    width: 79.599,
    height: 13.797,
    rx: 6.899,
    transform: "translate(30.778 111.439)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-6",
    "data-name": "Rectangle 6",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(30.778 153.892)",
    fill: "#ed6a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-6",
    "data-name": "Rectangle 8",
    width: 35.024,
    height: 7.429,
    rx: 3.715,
    transform: "translate(75.354 153.892)",
    fill: "#fbfbf2"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "group-42",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3129 57.311)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-42",
    "data-name": "Rectangle 3",
    width: 140.094,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-37",
    "data-name": "Rectangle 4",
    d: "M10,0H130.094a10,10,0,0,1,10,10V27.594a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-52",
    "data-name": "Icon - Image",
    transform: "translate(29.039 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-52",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-52",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-53",
    "data-name": "Icon - Image",
    transform: "translate(87.258 59.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-53",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-53",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-32",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(14.858 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-26",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-36",
    "data-name": "Rectangle 12",
    width: 80.66,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 146.462)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-31",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.066,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 48.066,
    height: 44.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-16",
    "data-name": "Rectangle 10",
    transform: "translate(73.231 43.514)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.005,
    height: 49.882,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 47.005,
    height: 44.882,
    fill: "none"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "group-43",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3286.076)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-43",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 187.854,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-38",
    "data-name": "Rectangle 4",
    d: "M10,0H44.575a0,0,0,0,1,0,0V187.854a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-54",
    "data-name": "Icon - Image",
    transform: "translate(81.367 25.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-54",
    "data-name": "Path 1",
    d: "M106.018,148.989a1.664,1.664,0,1,0-1.918-1.644A1.8,1.8,0,0,0,106.018,148.989Z",
    transform: "translate(-99.311 -141.599)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-54",
    "data-name": "Path 2",
    d: "M21.083,41.7H1.918A1.8,1.8,0,0,0,0,43.344V56.489a1.8,1.8,0,0,0,1.918,1.644h19.17a1.8,1.8,0,0,0,1.918-1.644V43.344A1.8,1.8,0,0,0,21.083,41.7Zm-.957,9.855-2.889-2.477a1.479,1.479,0,0,0-1.932.039c-1.647,1.408-4.761,4.082-4.761,4.082L8.6,51.531a1.512,1.512,0,0,0-1.886.024L2.88,54.84V44.161H20.131l0,7.394Z",
    transform: "translate(0 -41.7)",
    fill: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-6",
    "data-name": "Rectangle 15",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 78.538)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-6",
    "data-name": "Rectangle 17",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 63.679)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-6",
    "data-name": "Rectangle 21",
    width: 52.005,
    height: 7.429,
    rx: 3.715,
    transform: "translate(73.231 129.481)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-6",
    "data-name": "Rectangle 18",
    width: 44.575,
    height: 8.491,
    rx: 4.245,
    transform: "translate(59.434 108.255)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-6",
    "data-name": "Rectangle 23",
    width: 32.901,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 159.198)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-6",
    "data-name": "Rectangle 16",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 93.396)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-6",
    "data-name": "Rectangle 22",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(59.434 144.34)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-37",
    "data-name": "Rectangle 12",
    width: 32.901,
    height: 8.491,
    rx: 4.245,
    transform: "translate(6.368 50.943)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-11",
    "data-name": "Rectangle 13",
    width: 32.901,
    height: 6.368,
    rx: 3.184,
    transform: "translate(6.368 63.679)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-11",
    "data-name": "Rectangle 14",
    width: 31.84,
    height: 7.429,
    rx: 3.715,
    transform: "translate(6.368 75.354)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10-17",
    "data-name": "Rectangle 10",
    transform: "translate(59.434 16.981)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.802,
    height: 33.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 60.802,
    height: 28.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-11",
    "data-name": "Ellipse 2",
    transform: "translate(9.552 16.981)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 12.736,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.736,
    cy: 12.736,
    r: 10.236,
    fill: "none"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "group-44",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3129 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-44",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-55",
    "data-name": "Icon - Image",
    transform: "translate(59.088 56.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-55",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-55",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-33",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 109.316)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-27",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(15.92 128.42)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-38",
    "data-name": "Rectangle 12",
    width: 55.189,
    height: 11.675,
    rx: 5.837,
    transform: "translate(15.92 147.524)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-6",
    "data-name": "Rectangle 29",
    width: 38.208,
    height: 11.675,
    rx: 5.837,
    transform: "translate(88.09 164.505)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-16",
    "data-name": "Rectangle 30",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(107.193 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-16",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 11.675,
    rx: 5.837,
    transform: "translate(82.783 12.736)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-32",
    "data-name": "Rectangle 9",
    transform: "translate(15.92 40.33)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-6",
    "data-name": "Ellipse 3",
    transform: "translate(15.92 11.675)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 6.899,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.899,
    cy: 6.899,
    r: 4.399,
    fill: "none"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "group-45",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3287.137 203.774)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-45",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-56",
    "data-name": "Icon - Image",
    transform: "translate(58.238 56.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-56",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-56",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-34",
    "data-name": "Rectangle 7",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 99.764)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-28",
    "data-name": "Rectangle 11",
    width: 110.377,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 118.868)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-39",
    "data-name": "Rectangle 12",
    width: 72.17,
    height: 12.736,
    rx: 6.368,
    transform: "translate(14.858 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-17",
    "data-name": "Rectangle 30",
    width: 11.675,
    height: 2.123,
    transform: "translate(113.561 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-11",
    "data-name": "Rectangle 32",
    width: 11.675,
    height: 1.061,
    transform: "translate(113.561 25.472)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-11",
    "data-name": "Rectangle 33",
    width: 11.675,
    height: 3.184,
    transform: "translate(113.561 20.165)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-17",
    "data-name": "Rectangle 31",
    width: 19.104,
    height: 10.613,
    rx: 5.307,
    transform: "translate(14.858 15.92)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-33",
    "data-name": "Rectangle 9",
    transform: "translate(14.858 42.453)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.377,
    height: 46.698,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 105.377,
    height: 41.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-39",
    "data-name": "Rectangle 4",
    d: "M0,0H141.156a0,0,0,0,1,0,0V18.656a10,10,0,0,1-10,10H10a10,10,0,0,1-10-10V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 160.259)",
    fill: "#818181"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "group-46",
    className: "bg-group",
    "data-name": "group",
    transform: "translate(3444.212 261.085)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-46",
    "data-name": "Rectangle 3",
    width: 141.156,
    height: 188.915,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4-40",
    "data-name": "Rectangle 4",
    d: "M10,0H98.7a0,0,0,0,1,0,0V188.915a0,0,0,0,1,0,0H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12-40",
    "data-name": "Rectangle 12",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 30.778)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-6",
    "data-name": "Rectangle 24",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 42.453)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-6",
    "data-name": "Rectangle 25",
    width: 31.84,
    height: 6.368,
    rx: 3.184,
    transform: "translate(104.009 54.127)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-12",
    "data-name": "Rectangle 13",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 91.274)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-6",
    "data-name": "Rectangle 26",
    width: 38.208,
    height: 6.368,
    rx: 3.184,
    transform: "translate(44.575 102.948)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14-12",
    "data-name": "Rectangle 14",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 126.297)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-6",
    "data-name": "Rectangle 27",
    width: 65.802,
    height: 7.429,
    rx: 3.715,
    transform: "translate(16.981 137.972)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-6",
    "data-name": "Rectangle 28",
    width: 65.802,
    height: 6.368,
    rx: 3.184,
    transform: "translate(16.981 150.708)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2-12",
    "data-name": "Ellipse 2",
    transform: "translate(15.92 88.09)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 12.736,
    ry: 12.205,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.736,
    cy: 12.205,
    rx: 10.236,
    ry: 9.705,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9-34",
    "data-name": "Rectangle 9",
    transform: "translate(19.104 20.165)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.679,
    height: 50.943,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 58.679,
    height: 45.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Image-57",
    "data-name": "Icon - Image",
    transform: "translate(38.731 37.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-57",
    "data-name": "Path 1",
    d: "M106.093,149.212a1.77,1.77,0,1,0-1.993-1.756A1.888,1.888,0,0,0,106.093,149.212Z",
    transform: "translate(-99.125 -141.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-57",
    "data-name": "Path 2",
    d: "M21.9,41.7H1.993A1.885,1.885,0,0,0,0,43.456V57.493A1.888,1.888,0,0,0,1.993,59.25H21.908A1.888,1.888,0,0,0,23.9,57.493V43.456A1.892,1.892,0,0,0,21.9,41.7ZM20.91,52.225l-3-2.645a1.506,1.506,0,0,0-2.007.042c-1.711,1.5-4.947,4.359-4.947,4.359L8.933,52.2a1.538,1.538,0,0,0-1.96.025L2.992,55.733v-11.4H20.914l0,7.9Z",
    transform: "translate(0 -41.7)",
    fill: "#6b6b6b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/contact-bg.ecb8d1747f130d12775a58d75451df5a.svg";
export { ForwardRef as ReactComponent };